import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '../../tooltip/tooltip';
import { IconGuide } from '../../icons/guide';

export const FloatingButtonsGuide: React.FC = () => {
    const { t } = useTranslation();

    return (
        <Tooltip content={t('layout.floatingButtons.guide.tooltip')} position="top-right" arrowPosition={1.4}>
            <a
                href={'https://monery.zendesk.com/hc/cs'}
                target={'_blank'}
                rel="noreferrer"
                className="flex h-[4.8rem] w-[4.8rem] cursor-pointer items-center justify-center rounded-[10rem] transition-[border,background] hover:bg-brand-secondary vl:rounded-b-none vl:rounded-t-[10rem] vl:border-b vl:border-border [&_i]:h-[1.8rem] [&_i]:w-[1.8rem] [&_i]:text-brand-secondary [&_i]:transition-colors hover:[&_i]:text-text-inverse"
            >
                <IconGuide />
            </a>
        </Tooltip>
    );
};
